import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import {
  ITrainingChartData,
  ITrainingData,
} from './training-certification.interface';

@Component({
  selector: 'app-training-certification',
  templateUrl: './training-certification.component.html',
  styleUrls: ['./training-certification.component.scss'],
})
export class TrainingCertificationComponent implements OnInit {
  public trainingCertification!: ITrainingChartData[];
  loading: boolean = false;
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}

  columns = ['group', 'field1', 'field2'];
  colors = ['#377dc7', '#5bb362'];
  legends = ['Training', 'Certification'];

  getDate(date: string) {
    let datePipe = new DatePipe('en-US');
    return datePipe.transform(date, 'MMM d, y');
  }
  ngOnInit(): void {
    this.loading = true;
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.homeServiceRef.getTrainingCertification(id).subscribe((res) => {
        this.trainingCertification = res.trainingAndCertification.map(
          (data: ITrainingData, index: number) => {
            return {
              group: this.getDate(data.occurenceDate),
              field1: data.trainingCount,
              field2: data.certificationCount,
            };
          }
        );
        this.loading = false;
      });
    }
  }
}
